import React from 'react';

import Icon from '../Icon/Icon';

const AccountBlueIcon = (props) => {
    return (
        <Icon width='64' height='64' {...props}>
            <g transform='translate(13 9)' fill='none' fillRule='evenodd'>
                <path
                    d='M12.368 27.535c1.865 2.222 4.088 3.293 6.632 3.293 2.536 0 4.808-1.068 6.779-3.293H30c1.864 0 3.551.756 4.773 1.978a6.729 6.729 0 0 1 1.977 4.772v7.188c0 1.036-.42 1.973-1.098 2.652A3.738 3.738 0 0 1 33 45.223H5a3.738 3.738 0 0 1-2.652-1.098 3.738 3.738 0 0 1-1.098-2.652v-7.188c0-1.863.756-3.551 1.977-4.772A6.729 6.729 0 0 1 8 27.535z'
                    stroke='#34303D'
                    strokeWidth='2.5'
                />
                <circle stroke='#34303D' strokeWidth='2.5' cx='19' cy='11.795' r='11.281' />
                <path
                    stroke='#00D1D2'
                    strokeWidth='2'
                    strokeLinecap='round'
                    d='M24.649 35.946h6.675M25.2 13.865c-.95 2.529-3.515 4.283-6.376 4.283-2.73 0-4.82-1.936-5.855-4.283'
                />
            </g>
        </Icon>
    );
};

export default AccountBlueIcon;
